import {Component, Input} from '@angular/core';
import {selectFeatureFlag} from '@ox/data';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {ShopFeatureFlag} from '@ox/typings';
import {Subject, takeUntil, tap} from 'rxjs';
import {AutoDestroy} from '@ox/utils';


@Component({
  selector: 'webu-plan-offer-banner',
  templateUrl: './plan-offer-banner.component.html'

})
export class PlanOfferBannerComponent {
  @AutoDestroy
  destroy$: Subject<void> = new Subject<void>();
  @Input() linkCheck: string;
  bannerToggle : boolean;
  bannerchat$ = this.store.select(selectFeatureFlag({id: ShopFeatureFlag.SHOP_ALL_PLANS_LINK, group: 'SHOP'}))
  .pipe(
    takeUntil(this.destroy$),
    tap((flag) => {
      this.bannerToggle = flag === 'true';
    })
  ).subscribe(); 
  
  constructor(private router: Router, private store: Store) {}

  goToShop() {
    this.router.navigate(['./onstar/shop']);
  }
}
